import {CollapseButtonContainer, CollapseButtonWrapper, CollapseIconWrapper} from "./CollapseButton.styles";
import { CollapseButtonIcon } from "shared/ui/icons/collapseButtonIcon";
import { useHudCollapse } from "widgets/hud/model/collapseStore";

export const CollapseButton = () => {
    const collapsed = useHudCollapse((s) => s.collapsed);
    const toggle = useHudCollapse((s) => s.toggle);

    return (
        <CollapseButtonWrapper $collapsed={collapsed}>
            <CollapseButtonContainer $collapsed={collapsed} onClick={toggle}>
                <CollapseIconWrapper $collapsed={collapsed}>
                    <CollapseButtonIcon/>
                </CollapseIconWrapper>
                {collapsed ? "" : "Свернуть"}
            </CollapseButtonContainer>
        </CollapseButtonWrapper>
    );
};
